<div class="checkout-container">
  <!--<h2>Realizar Pago con PayPal</h2>-->

  <div *ngIf="loading" class="loading-spinner">
    <div class="spinner"></div>
    <p>Cargando opciones de pago...</p>
  </div>

  <div *ngIf="paymentSuccessful" class="payment-success">
    <h3>¡Pago Completado!</h3>
    <p>Tu pago ha sido procesado correctamente. Gracias por tu compra.</p>
    <p>
      En breve recibirás un correo electrónico con los detalles de tu
      transacción.
    </p>
  </div>

  <div *ngIf="paymentError" class="payment-error">
    <p>{{ paymentError }}</p>
    <p>
      Si el problema persiste, por favor contacta con nuestro servicio de
      atención al cliente.
    </p>
  </div>

  <div *ngIf="!loading && !paymentSuccessful">
    <div class="payment-section">
      <h3>Pagar con PayPal</h3>
      <p>
        Paga de forma segura usando tu cuenta de PayPal o una tarjeta de
        crédito/débito.
      </p>

      <div class="amount-selector">
        <label for="amount"
          >Importe a pagar (EUR):
          <h3>{{ orderAmount | currency : 'EUR' : 'symbol' : '1.2-2' }}</h3>
        </label>
      </div>

      <div id="paypal-button-container" class="paypal-button-container"></div>

      <div class="payment-info">
        <p><strong>Información importante:</strong></p>
        <ul>
          <li>
            Al hacer clic en el botón de PayPal, serás redirigido a la
            plataforma segura de PayPal.
          </li>
          <li>
            No se aplicarán cargos adicionales por usar este método de pago.
          </li>
          <li>
            Si tienes problemas con tu pago, por favor desactiva cualquier
            bloqueador de anuncios.
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
